<template>
  <div
    class="pressure"
    :class="'pressure_' + classIndex"
    @click="handleNoise()"
  >
    <div class="title">
      <div class="title-left">
        <h1>{{atmparam.name}}</h1>
        <p>{{atmparam.remark}}</p>
      </div>
      <div class="title-right">
        <div class="right-img">
          <img
            :src="atmparam.img"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    atmparam: Object,
    index: Number,
    flag: Boolean,
  },
  computed: {
    classIndex () {
      return this.index % 4
    },
  },
  methods: {
    handleNoise () {
      if (!this.flag) {
        this.$router.push({
          name: 'Noise',
          query: {
            id: this.atmparam.id,
            name: this.atmparam.name,
            remark: this.atmparam.remark,
            img: this.atmparam.img,
            index: this.index,
          } 
        });
      }
    }
  }
}
</script>

<style style lang="scss" scoped>
.pressure_0 {
  background: linear-gradient(
    90deg,
    rgba(105, 132, 244, 1),
    rgba(148, 103, 242, 1)
  );
}

.pressure_1 {
  background: linear-gradient(
    45deg,
    rgba(244, 204, 110, 1),
    rgba(249, 145, 190, 1)
  );
}
.pressure_2 {
  background: linear-gradient(
    90deg,
    rgba(106, 228, 239, 1),
    rgba(98, 114, 230, 1)
  );
}
.pressure_3 {
  background: linear-gradient(
    90deg,
    rgba(246, 92, 214, 1),
    rgba(206, 130, 227, 1)
  );
}
</style>